<template>
  <gk-dialog :show="isShow" title="新增账户" width="600px" class="dialog-account" @close="onClose">
    <el-form label-width="100px" ref="form" :model="form">
      <el-form-item label="账户类型：" prop="CollectionAccountType">
        <el-radio-group v-model="form.CollectionAccountType" >
          <!-- <el-radio :label="3" border v-if="userInfo.LoginAccountType==1">支付宝</el-radio> -->
          <el-radio :label="1" border>银行卡</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="户名：">
        <span class="value">{{userInfo.LoginName}}</span>
      </el-form-item>
      <el-form-item label="账号：" prop="BankCardNo">
        <el-input :placeholder="form.CollectionAccountType==1?'请输入银行卡号':'请输入支付宝账号'" v-model="form.BankCardNo"></el-input>
      </el-form-item>
      <el-form-item label="选择银行：" v-if="form.CollectionAccountType==1"  prop="BankName">
        <el-select filterable v-model="form.BankName">
          <el-option v-for="(item,index) in bankList" :key="index" :label="item.CodeName1" :value="item.CodeName1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=""  prop="IsDefault">
        <el-checkbox label="设置默认账号" name="default" v-model="form.IsDefault"></el-checkbox>
      </el-form-item>
      
    </el-form>
    <p class="warn">注：根据国家法律规定，提现用户必须实名认证，若提供的账号与用户名不符，则将提现失败。</p>
    <button class="btn-primary" @click="submit">确认</button>
  </gk-dialog>
</template>
<script>
import {
  AddCollectionAccount,
  AddCompanyBankCardInfo,
  SureAddBankAccount,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
import gkDialog from '@/components/gkDialog.vue'
export default {
  components:{
    gkDialog,
  },
  data(){
    return{
      form:{
        CollectionAccountType:1,
        BankCardNo:'',
        BankName:'',
        IsDefault:'',
      },
    }
  },
  props:{
    isShow:{
      type:Boolean,
      default:false,
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
      bankList:state=>state.bankList
    }),
  },
  created() {
    if(this.bankList.length==0){
      this.$store.dispatch('loadBankList','Bank');
    }
  },
  methods: {
    onClose(){
      this.$emit('close');
    },
    //添加账号
    submit(){
      if(this.CollectionAccountType==''){
        this.$toast('请选择账号类型！');
        return;
      }
      if(this.BankCardNo==''){
        this.$toast('请输入账号！');
        return;
      }
      if(this.BankName=='' && this.CollectionAccountType==1){
        this.$toast('请选择开户银行！');
        return;
      }
      if(this.userInfo.LoginAccountType==1){
        this.addPersonalAccount();
      }else if(this.userInfo.LoginAccountType==2){
        this.addCompanyAccount();
      }
    },
    
    //添加企业账号
    addCompanyAccount(){
      let params={
        ...this.form,
        CompanyID:this.userInfo.LoginAccountId
      }
      AddCompanyBankCardInfo(params).then(r=>{
        if(r.Result==1){
            this.$emit('success');
            this.$refs.form.resetFields();
        }else{
          this.onConfirm(r.Data.ResultCode,r.Data.BankName)
        }
      })
    },
    //添加个人账号
    addPersonalAccount(){
      let params={
        CollectionAccount:this.form.BankCardNo,
        CollectionAccountType:this.form.CollectionAccountType,
        IsDefault:this.form.IsDefault,
        UserCode:this.userInfo.UserCode
      }
      //如果添加的是银行账号，则传银行名称
      if(this.form.CollectionAccountType==1){
        params['CollectionAccountName']=this.form.BankName;
      }
      AddCollectionAccount(params).then(r=>{
        if(r.Result==1){
            this.$emit('success');
            this.$refs.form.resetFields();
        }else{
          if(r.Result==0 && !r.Data){
            this.$toast(r.Message);
          }else{
            this.onConfirm(r.Data.ResultCode,r.Data.BankName);
          }
        }
      })
    },
    //提交银行卡账号异常提示
    onConfirm(code=1,bankname=''){
      let msg='',cancelBtn='',confirmBtn='';
      switch (code) {
        case 1:
          //卡号异常
          msg=`请确认您添加的银行卡信息：开户银行${this.form.BankName},卡号${this.form.BankCardNo}的银行卡。若填写错误，可能导致提现/退款不成功。`;
          cancelBtn='返回修改';
          confirmBtn='确认无误';
          break;
        case 2:
          //是信用卡
          msg=`系统检测到您${this.form.BankName},卡号${this.form.BankCardNo}的银行卡为信用卡。速派平台不支持提现/退款至信用卡，如您确认非信用卡，可直接添加。`;
          cancelBtn='返回修改';
          confirmBtn='确认无误';
          break;
        case 3:
          //开户行异常
          msg=`系统检测到您${this.form.BankName},卡号${this.form.BankCardNo}的银行卡开户银行为${bankname}，是否需要为您变更为${bankname}`;
          cancelBtn='返回修改';
          confirmBtn='确认无误';
          break;
        case 4:
          //账号已存在
          msg=`收款账户已存在！`;
          cancelBtn='返回修改';
          confirmBtn='知道了';
          break;
      }
      this.$confirm(msg,{
        confirmButtonText:confirmBtn,
        cancelButtonText:cancelBtn,
      }).then(()=>{
        SureAddBankAccount({
          BankName:code==3?bankname:this.form.BankName,
          BankAccount:this.form.BankCardNo,
          UserCode:this.userInfo.UserCode
        }).then(r=>{
          if(r.Result==1){
            this.$emit('success');
            this.$refs.form.resetFields();
          }else{
            this.$toast(r.Message);
          }
        })
      })
    },
  },
}
</script>
<style lang="scss">
  .dialog-account{
    .value{
      font-size: 14px;
      color: #333;
    }
    .el-form-item__label{
      font-weight: bold;
      color: #333;
    }
    .el-radio__inner{
      display: none;
    }
    .el-select{
      width: 100%;
    }
    .warn{
      line-height: 24px;
      padding-left: 100px;
      font-size: 14px;
      color: #999;
    }
    .btn-primary{
      display: block;
      width: 100px;
      height: 32px;
      line-height: 32px;
      margin: 30px auto 10px;
      font-size: 14px;
    }
  }
</style>